import Collection from 'core/model/Collection';
import { action, observable } from 'mobx';
import { Model } from 'core/model';

/**
 * This represents a "View" belonging to a Collection, allowing us to expose a subset of Collection data without modifying
 * the parent Collection at all.
 *
 * @constructor
 * @class
 */
export class ViewCollection extends Collection {
  @observable.ref
  parentCollection: Collection;

  /**
   * @param data generally this should be filtered data, though you might alternatively perform filtering after instantiation.
   * @param parentCollection
   * @param options options for creating the Collection.
   */
  constructor(data: Model[], parentCollection: Collection, options = {}) {
    super(data, options);
    this.parentCollection = parentCollection;
  }

  /**
   * This is the main reason this class exists in the first place - we need to propagate changes in the View back into the parent.
   */
  @action
  remove = (ids: string[], destroyModels?: boolean) => {
    this.parentCollection.remove(ids, destroyModels);
  };

  get url() {
    console.error('Illegal attempt to fetch from a ViewCollection');
    return '';
  }

  get model() {
    return this.parentCollection?.model;
  }
}
